import { Box, Button, InputAdornment, Stack, Typography } from "@mui/material";
import CustomDialog from "global/components/CustomDialog/CustomDialog";
import CustomTextInput from "global/components/CustomTextInput/CustomTextInput";
import { renameCampaign } from "../CampaignService";
import { useState } from "react";
import { handleErrorMessage, openSuccessNotification } from "helpers/methods";
import { isEmpty } from "lodash";

interface CustomProps {
  isOpen: boolean;
  setOpen: Function;
  campaignId: number;
  refresh: Function;
}

const RenameModal = (props: CustomProps) => {
  const [name, setName] = useState<string>("");
  const handleClose = () => {
    props.setOpen(false);
  };

  const handleUpdatedName = async () => {
    try {
      await renameCampaign(props.campaignId, name.trim());
      openSuccessNotification("Campaign renamed successfully");
      props.setOpen(false);
      props.refresh();
    } catch (error: any) {
      handleErrorMessage(error);
    } finally {
      setName("");
    }
  };

  const getTextField = () => {
    return (
      <Stack spacing={3}>
        <CustomTextInput
          label="Campaign name"
          value={name}
          onChange={(event: any) => {
            setName(event.target.value);
          }}
          required
          placeHolder="Enter the campaign name"
          propsToInputElement={{ minLength: 1, maxLength: 90 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <span style={{ fontSize: "0.75rem" }}>{name?.length} / 90</span>
              </InputAdornment>
            ),
          }}
        />
      </Stack>
    );
  };

  const getFooter = () => {
    return (
      <Stack direction="row" spacing={1}>
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={isEmpty(name.trim())}
          onClick={handleUpdatedName}
        >
          Update
        </Button>
      </Stack>
    );
  };

  return (
    <CustomDialog
      handleDialogClose={handleClose}
      isDialogOpen={props.isOpen}
      closable
      closeButtonVisibility
      body={getTextField()}
      title={
        <Typography variant="h4" color="#7551D0">
          Rename Campaign
        </Typography>
      }
      footer={getFooter()}
    />
  );
};

export default RenameModal;
